import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';
import { ThemeContext } from '../../context/ThemeContext';
import { TextField } from '@mui/material';

export const profitLoss = new Map();

export const SetPLValue = (id, value) => {
  profitLoss.set(id, value);
}

export const deletePLValue = (id) => {
  profitLoss.delete(id);
}

function AccountFooter({ searchQuery, setSearchQuery }) {
  const { t } = useTranslation()
  const { accountSummary = [] } = useSelector(state => state.accountSummary, shallowEqual)
  const { updatePL } = useSelector((state) => state.profitLoss);
  const [floatingPL, setFloatingPL] = useState(0)
  const { darkMode } = useContext(ThemeContext)


  const calculatedEquity = accountSummary.balance ? (parseFloat(accountSummary.balance) + parseFloat(floatingPL))?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
  const calculatedMarginLevel = calculatedEquity && accountSummary.usedMargin ? ((parseFloat(accountSummary.balance) + parseFloat(floatingPL)) / parseFloat(accountSummary.usedMargin) * 100)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
  const freeMargin = calculatedEquity ? (parseFloat(accountSummary.balance) + parseFloat(floatingPL) - parseFloat(accountSummary.usedMargin))?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';

  useEffect(() => {
    let pl = 0;
    if ([...profitLoss].length <= 0) {
      setFloatingPL(0);
      return;
    }
    [...profitLoss].map(item => {
      pl += parseFloat(item[1]) || 0
    })
    setFloatingPL(pl)
  }, [updatePL])
  const imgSrc = darkMode ? '/hs-white.png' : '/hs-logo.png'
  return (
    <div className='flex items-center px-1 justify-between' style={{ backgroundColor: darkMode ? "#151924" : "#fff", color: darkMode ? 'var(--lightText)' : 'var(--darkText)', height: 30 }}>
      <TextField name="searchQuery" size="small" variant="outlined" placeholder={t("mobSearch")} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ width: '250px', mt: 0.5 }} InputProps={{ sx: { fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />
      <div className='flex items-center'>
        <div className='text-sm mr-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('balance')}: {(accountSummary?.balance || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm mx-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('credit')}: {(accountSummary?.credit || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm mx-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('floatingPL')}: {parseFloat(floatingPL).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm mx-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('equity')}: {calculatedEquity} </div>
        <div className='text-sm mx-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('usedMargin')}: {(accountSummary?.usedMargin || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm mx-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('freeMargin')}: {freeMargin} </div>
        <div className='text-sm mx-2' style={{ fontSize: '0.85rem', fontWeight: 500 }}> {t('marginLevel')}: {calculatedMarginLevel}% </div>
      </div>

      <div className='flex items-center opacity-50'>
        <small>Powered by </small><a href="https://hybridsolutions.com/" target='_blank'><img src={imgSrc} alt="hs" style={{ height: darkMode ? 40 : 20 }} className='ms-2' />
        </a>
      </div>
    </div>
  );
}

export default AccountFooter;
